import { render, staticRenderFns } from "./ModalTakeMaterials.vue?vue&type=template&id=8a5bb4cc&"
import script from "./ModalTakeMaterials.vue?vue&type=script&lang=js&"
export * from "./ModalTakeMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports